import { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import PageHeader from "../../components/PageHeader";
import { toast } from "sonner";
import noticeBoardApis from "../../api/noticeBoardApis";
import { useBranchCode } from "../../util/hooks/useBranch";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { useLocation } from "react-router-dom";

export default function CreateNotice() {
  const location = useLocation();
  const editNotice = location.state?.notice;

  const [formData, setFormData] = useState({
    appliesTo: "",
    activeFrom: "",
    activeTo: "",
    notice: "",
  });

  const branchDetails = useSelector((state: RootState) => state.access);

  const handleInputChange = (name: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const branchCode = useBranchCode();

  useEffect(() => {
    if (editNotice) {
      setFormData({
        appliesTo: "",
        activeFrom: editNotice.activeFrom.split("T")[0],
        activeTo: editNotice.activeTo.split("T")[0],
        notice: editNotice.notice,
      });
    }
  }, [editNotice]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!branchDetails) {
      toast.error("Branch details not loaded");
      return;
    }

    if (!formData.activeFrom || !formData.activeTo || !formData.notice) {
      toast.error("Please fill all the required fileds");
      return;
    }

    if (new Date(formData.activeTo) < new Date(formData.activeFrom)) {
      toast.error("Active To must be after Active From");
      return;
    }

    const payload = {
      notice: formData.notice,
      activeFrom: new Date(formData.activeFrom).toISOString(),
      activeTo: new Date(formData.activeTo).toISOString(),
      branchCode,
      // schoolBranch: branchDetails.schoolBranch,
      // school: branchDetails.school,
    };

    const res = await noticeBoardApis.createNotice(payload);

    if (res) {
      toast.success("Notice created successfully");

      setFormData({
        appliesTo: "",
        activeFrom: "",
        activeTo: "",
        notice: "",
      });
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <PageHeader showBack />

      <div className="bg-white rounded-lg px-5 md:px-10 py-9">
        <form className="grid gap-7" onSubmit={handleSubmit}>
          <div className="grid md:grid-cols-2 gap-7">
            <CustomSelect
              label="Select Recipient*"
              placeholder="Select recipient"
              name="appliesTo"
              value={formData.appliesTo}
              options={["STUDENT", "STAFF", "BOTH"]}
              // onChange={(value: string) =>
              //   handleInputChange("appliesTo", value)
              // }
              onChange={() => {}}
              selectClassName="w-full"
            />

            <div className="flex flex-col gap-2">
              <label className="text-sm font-medium text-neutral-500">
                Notice Running Window*
              </label>

              <div className="flex items-center gap-3">
                <CustomInput
                  name="activeFrom"
                  type="date"
                  value={formData.activeFrom}
                  onChange={(e: any) =>
                    handleInputChange("activeFrom", e.target.value)
                  }
                  className="flex-1"
                />

                <span className="text-neutral-400 font-semibold">→</span>

                <CustomInput
                  name="activeTo"
                  type="date"
                  value={formData.activeTo}
                  onChange={(e: any) =>
                    handleInputChange("activeTo", e.target.value)
                  }
                  className="flex-1"
                />
              </div>
            </div>
          </div>

          <CustomInput
            name="notice"
            label="Message*"
            value={formData.notice}
            isTextarea
            maxLength={200}
            showCounter
            onChange={(e: any) => handleInputChange("notice", e.target.value)}
            placeholder="Type here...."
          />

          <div className="flex justify-end items-end">
            <CustomButton
              type="submit"
              color="bg-primary-500"
              text={editNotice ? "Update Notice" : "Create Now"}

            />
          </div>
        </form>
      </div>
    </div>
  );
}
